module.exports = "/images/pin-light.png?a0ff91695577e608340bfcf5b3f0dac5";